const TIME_OPTIONS = [
  { key: '1', text: '朝', value: '7' },
  { key: '2', text: '夜', value: '21' },
]
export {
  TIME_OPTIONS
}
